module.exports = __webpack_public_path__ + "img/2289.1683428b.gif";